<app-module>
  <div class="header" header>
    {{ 'STATS.leaderboardHeader' | translate : { month: ('GENERAL.months.' + date.month() | translate) } }}
    {{ date.year() }}
    <span class="arrows">
      <span class="arrow" (click)="prevMonth()">&larr;</span>
      <span class="arrow" (click)="nextMonth()">&rarr;</span>
    </span>
  </div>

  <div class="example-container">
    <mat-table #table [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="position">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-Nr">
          {{ 'STATS.position' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-column-Nr">
          <div class="pos">{{ element.position }}</div>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-Name">
          {{ 'STATS.name' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-column-Name">
          {{ element.alias !== 'anonym' && element.alias ? element.alias : ('STATS.noName' | translate) }}
        </mat-cell>
      </ng-container>

      <!-- Points Column -->
      <ng-container matColumnDef="punkte">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-Punkte">
          {{ 'STATS.points' | translate }}
        </mat-header-cell>
        <mat-cell class="points mat-column-Punkte" *matCellDef="let element"> {{ element.points }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ selected: row.isRequester }"></mat-row>
    </mat-table>

    <app-info-popup #popup [position]="{ top: '0', left: '0', right: '0', bottom: '0' }">
      <header>{{ 'STATS.ALIASPOPUP.header' | translate }}</header>

      <main>
        <form [formGroup]="aliasForm" action="">
          <app-input [error]="aliasForm.controls['alias'].invalid && aliasForm.controls['alias'].touched">
            Alias:
            <input
              type="text"
              [formControlName]="'alias'"
              placeholder="{{ 'SETTINGS.placeholderAlias' | translate }}"
            />
            <div app-input-error *ngIf="aliasForm.controls['alias'].invalid && aliasForm.controls['alias'].touched">
              {{ 'GENERAL.FORMS.aliasInvalid' | translate }}
            </div>
          </app-input>
        </form>
      </main>
      <footer>
        <button mat-button (click)="saveAlias(true)">{{ 'STATS.ALIASPOPUP.cancelBtn' | translate }}</button>
        <button mat-raised-button color="accent" (click)="saveAlias()">
          {{ 'STATS.ALIASPOPUP.submitBtn' | translate }}
        </button>
      </footer>
    </app-info-popup>
  </div>
</app-module>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/ranking/ranking.component.html